module.exports = __webpack_public_path__ + "img/cool-center.f1c2501a.svg";